import { get } from '../services/Generic.api';

export const fetchClientData = async (clientId) => {
  try {
    return await get(`/client/${clientId}`);
  } catch (error) {
    console.error(`Erro ao buscar dados do cliente ${clientId}:`, error);
    throw error;
  }
};

export const fetchClientSubjects = async (clientId, inputValue = '', limit = 20) => {
  try {
    if (!clientId) return [];
    const term = (inputValue || '').trim();
    if (term.length < 3) return [];

    const qs = new URLSearchParams({
      client: String(clientId),
      subject: term,
      limit: String(limit),
    }).toString();

   const res = await get(`/groupers/client-subjects/?${qs}`);
    const raw = Array.isArray(res) ? res : (Array.isArray(res?.subjects) ? res.subjects : []);
    return raw.map((s) => ({ value: String(s), label: String(s) }));
  } catch (err) {
    console.error('Erro ao buscar assuntos:', err);
    return [];
  }
};

export const fetchClientClippingSelections = async (clientId) => {
  try {
    return await get(`/clippings-selection/?client=${clientId}`);
  } catch (error) {
    console.error(`Erro ao buscar seleções de clippings do cliente ${clientId}:`, error);
    throw error;
  }
};
